import React from 'react';
import { sp_chevron_down, upload_icon } from '../../assets/img';
import * as styles from './basic-upload-file.module.scss';

const BasicUploadFile = () => {
  return (
    <div className={styles.fileUploader}>
      <div className={styles.info}>
        <img src={upload_icon} alt="upload_icon" />
        <span className={styles.dragText}>Drag and drop your file here</span>
        <li className={styles.limitText}>Limit 150MB per file</li>
        <span className={styles.fileType}>e.g. : .pdf</span>
        <span className={styles.orText}>OR</span>
        <button className={styles.browserFile}>
          Browse File{' '}
          <img src={sp_chevron_down} alt="sp_chevron_down" className={styles.dropdownIcon} />
        </button>
      </div>
    </div>
  );
};

export default BasicUploadFile;
